import React, { useContext, useEffect, useRef, useState } from 'react';
import './index.scss';
import Breadcrumb from '../../DrugDetails/Breadcrumb/index.js';
import { SignupPromoBanner } from '../SignupPromoBanner/index.js';
import AppPromoV1 from '../../common/AppPromoV1/index.js';
import {
  COUPONPAGEFAQS,
  DRUG_CLASS_CTA,
  INTELLIMIZE_COUPON_EVENT,
  INTELLIMIZE_LOYALTY_SIGN_UP_STARTED,
  WALMART_PBA_CLIENT_NAME
} from '../../../constants/defaults.js';
import _ from 'lodash';
import Image from '../../common/Image.jsx';
import { useTranslation } from 'react-i18next';
import PriceInfoToolTip from '../CouponModal/PriceInfoAB/PriceInfo.js';
import { fetchCouponData } from '../../../services/Api/Coupon/CouponService.js';
import { AuthContext } from '../../../Contexts.js';
import AuthenticateModal from '../../HomeDeliveryNew/AuthenticateModal/index.js';
import Dialog from '../../common/Dialog/index.js';
import DialogCloseButton from '../../common/Dialog/DialogCloseButton.js';
import SendContact from '../CouponModal/SendContact.jsx';
const printJs = typeof window !== 'undefined' ? require('print-js') : undefined;

const CouponPageAB = ({ drugName = '' }) => {
  const item =
    typeof localStorage !== 'undefined' &&
    localStorage.getItem('couponVariation1') &&
    JSON.parse(localStorage.getItem('couponVariation1'));
  const drugData = item && item?.drugData;
  const selectedDisplayQuantity = item && item?.selectedDisplayQuantity;
  const [pdfUrl, setPdfUrl] = useState('');
  const [pdfLoading, setPdfLoading] = useState(false);
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hiddenParams, setHiddenParams] = useState({});
  const [contactSent, updateContactSent] = useState(false);
  const [sendType, setSendType] = useState('');
  const [isContactLoading, setContactLoading] = useState(true);
  const [fetchContactError, setFetchContactError] = useState(false);
  let couponShowHideInfoTooltipFunc = useRef(null);
  const { t } = useTranslation();
  const userData = useContext(AuthContext)?.userData;
  const closeButtonRef = useRef(null);
  const isLoggedIn = userData?.isLoggedIn;
  const cheapestPrice = !_.isEmpty(item?.Prices) && item?.Prices[0];

  let eventObj = {
    memberBalance: item?.userPoints,
    drugName: drugData?.name,
    seoName: drugData?.seoName,
    NDC: cheapestPrice.preferredNdc,
    drugBrand: drugData?.drugType
      ? drugData?.drugType
      : drugData?.isGeneric
      ? 'generic'
      : 'brand',
    drugForm: drugData?.form,
    drugDosage: drugData?.dosage,
    drugQuantity: drugData?.quantity,
    drugQuantityUnit: 'count',
    pbm: cheapestPrice.pBAName,
    pharmacyPrice: cheapestPrice.Price,
    priceUsualAndCustomary: cheapestPrice.UsualAndCustomary,
    singlecarePrice: cheapestPrice.Price,
    lowestPrice: item?.lowestPrice,
    lowestPricePharmacyName: item?.lowestPricePharmacyName,
    loyaltyApplicable: cheapestPrice.LoyaltyApplicable,
    loyaltyBonusSavings: cheapestPrice.LoyaltyBonusSavings,
    loyaltyExcluded: cheapestPrice.LoyaltyExcluded,
    loyaltyPrice: cheapestPrice.LoyaltyPrice,
    maxPharmacyPosition: item?.maxPharmacyPosition,
    GPI: drugData?.gpi,
    network: item?.Pharmacy?.network,
    pharmacyNetPrice: cheapestPrice.LoyaltyPrice,
    memberSavings: !_.isEmpty(cheapestPrice.LoyaltyDiscounts)
      ? cheapestPrice.LoyaltyDiscounts[0].discountAmount
      : '',
    bonusSavings: cheapestPrice.LoyaltyBonusSavings
  };
  let sendCouponObj = {
    ...eventObj,
    pharmacyName: item?.Pharmacy?.Name,
    pharmacyPosition: item?.position,
    pharmacyDistance: item?.Pharmacy?.Distance
  };

  const modifiedFaqs = COUPONPAGEFAQS.map(faq => {
    if (faq.Question === 'How does SingleCare membership work?' && isLoggedIn) {
      return {
        ...faq,
        Answer:
          'It’s totally free to join and lets you access special Member Bonus Savings. Be sure to sign-up using the same legal name and birth date used on your prescriptions. This is how we apply your Member Bonus Savings.'
      };
    }
    return faq;
  });

  useEffect(() => {
    if (!_.isEmpty(pdfUrl)) {
      setContactLoading(false);
      setPdfUrl(pdfUrl);
    } else {
      fetchContactData();
    }
  }, [pdfUrl]);

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
      document.getElementById('sendContactField').focus();
    } else {
      document.body.style.overflow = '';
    }
  }, [isModalOpen]);

  // Fetch Coupon Data
  const fetchContactData = async () => {
    setContactLoading(true);
    try {
      const { PartnerUser, PartnerPassword } =
        !_.isEmpty(item.Prices) && item.Prices[0];
      const contactResponse = await fetchCouponData(
        PartnerUser,
        PartnerPassword,
        '65',
        {},
        drugData?.seoName,
        cheapestPrice.Price,
        cheapestPrice.LoyaltyApplicable,
        cheapestPrice.LoyaltyExcluded,
        cheapestPrice.LoyaltyBonusSavings,
        cheapestPrice.preferredNdc
      );
      if (!_.isEmpty(contactResponse.PDFUrl)) setPdfUrl(contactResponse.PDFUrl);
      else setFetchContactError(true);
      if (!_.isEmpty(contactResponse)) {
        let finalEventObj = {
          ...eventObj,
          event: 'couponGenerated',
          authNumber: contactResponse.MemberNumberFull,
          grpNumber: contactResponse.GroupNumber,
          bin: contactResponse.BIN,
          pcn: contactResponse.PCN,
          geniusRxPrice: item?.geniusRxPrice
        };
        setHiddenParams({
          authNumber: contactResponse.MemberNumberFull,
          grpNumber: contactResponse.GroupNumber,
          bin: contactResponse.BIN,
          pcn: contactResponse.PCN
        });
        _.triggerGTMVirtualPageViewEvent(finalEventObj);
        _.sendIntellimizeEvent(INTELLIMIZE_COUPON_EVENT.GENERATE_COUPON);
        _.sendIntellimizeEvent(
          INTELLIMIZE_COUPON_EVENT.PRESCRIPTION_COUPON_GENERATE
        );
      }
    } catch (err) {
      console.log(err);
      setFetchContactError(true);
    } finally {
      setContactLoading(false);
    }
  };

  const handlePrintClick = async (event = { preventDefault() {} }) => {
    event.preventDefault();
    setPdfLoading(true);
    try {
      const { PartnerUser, PartnerPassword } = item.Prices[0];
      const pdfParams = {
        drug: item?.doNotMarket ? 'Your Prescription' : drugData?.name,
        qty: selectedDisplayQuantity,
        form: drugData?.form,
        price: `${
          isLoggedIn && cheapestPrice.LoyaltyApplicable
            ? cheapestPrice.LoyaltyPrice
            : cheapestPrice.Price
        }`,
        dsg: drugData?.dosage,
        pharmacy: item?.Pharmacy?.Name
      };
      const couponData = await fetchCouponData(
        PartnerUser,
        PartnerPassword,
        '2',
        pdfParams,
        drugData?.seoName,
        cheapestPrice.Price,
        cheapestPrice.LoyaltyApplicable,
        cheapestPrice.LoyaltyExcluded,
        cheapestPrice.LoyaltyBonusSavings,
        cheapestPrice.preferredNdc
      );
      if (!_.isEmpty(couponData.PDFUrl)) {
        _.triggerGTMVirtualPageViewEvent({
          ...sendCouponObj,
          event: 'printCouponGenerated',
          buttonLocation: 'coupon_modal',
          chainCode: item?.Pharmacy?.chainCode,
          authNumber: couponData.MemberNumberFull,
          grpNumber: couponData.GroupNumber,
          bin: couponData.BIN,
          pcn: couponData.PCN
        });
        _.sendIntellimizeEvent(INTELLIMIZE_COUPON_EVENT.PRINT_COUPON_GENERATED);
        printJs({
          printable: couponData.PDFUrl,
          type: 'image'
        });
        setPdfLoading(false);
        return;
      }

      setPdfLoading(false);
    } catch (err) {
      console.log(err);
      setPdfLoading(false);
    }
  };

  const handleTextEmailCoupon = (event, type) => {
    event.preventDefault();
    setSendType(type);
    setIsModalOpen(true);
    _.triggerGTMVirtualPageViewEvent({
      ...sendCouponObj,
      event:
        type === 'email' ? 'couponEmailButtonClick' : 'couponTextButtonClick',
      buttonLocation: 'full_screen_coupon_page',
      chainCode: item.Pharmacy.chainCode
    });
    _.sendIntellimizeEvent(
      type === 'email'
        ? INTELLIMIZE_COUPON_EVENT.COUPON_EMAIL_BUTTON_CLICK
        : INTELLIMIZE_COUPON_EVENT.COUPON_TEXT_BUTTON_CLICK
    );
  };

  const setFocusToCloseButton = event => {
    if (!_.isEmpty(event.relatedTarget)) {
      let relatedClassName = event.relatedTarget.className;
      if (relatedClassName.includes('dialogComponent')) {
        return;
      } else {
        closeButtonRef.current.focus();
      }
    }
  };

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const links = document.querySelectorAll(
      'a[href="#openSignupFromCouponPage"]'
    );
    const handleClick = e => {
      e.preventDefault();
      setShowSignupModal(true);
      _.triggerGTMVirtualPageViewEvent({
        event: 'SignUpStarted',
        loyaltySignupPath: 'Click here_in_FAQs'
      });
      _.sendIntellimizeEvent(INTELLIMIZE_LOYALTY_SIGN_UP_STARTED);
    };
    links.forEach(link => link.addEventListener('click', handleClick));

    return () => {
      links.forEach(link => link.removeEventListener('click', handleClick));
    };
  }, []);

  const handleLoyaltySignUpClick = () => {
    setShowSignupModal(true);
    _.triggerGTMVirtualPageViewEvent({
      event: 'SignUpStarted',
      loyaltySignupPath: 'Member_bonus_message'
    });
    _.sendIntellimizeEvent(INTELLIMIZE_LOYALTY_SIGN_UP_STARTED);
  };

  return (
    <div className="couponPageMainSection">
      {showSignupModal && (
        <div className="mainModal afterSignupmodal">
          <div
            className="transparentBg"
            onClick={() => setShowSignupModal(false)}
          ></div>
          <div className="signUpModal">
            <AuthenticateModal
              hideAuthenticateModal={() => setShowSignupModal(false)}
            />
          </div>
        </div>
      )}
      {isModalOpen && (
        <div className="mainModal">
          <div
            className="transparentBg"
            onClick={() => setIsModalOpen(false)}
          ></div>
          <div className="couponPageModalWrapper">
            <Dialog
              className="modalContent"
              onBlur={e => setFocusToCloseButton(e)}
              escKeyFunction={() => setIsModalOpen(false)}
              isModalOpen={isModalOpen}
            >
              <div className="headingWrap">
                <div id="dialogTitleHeading" className="dialogTitleHeading">
                  <h2>{`${
                    sendType === 'text' ? 'Text' : 'Email'
                  } your coupon`}</h2>
                  <span>
                    {drugName}, {selectedDisplayQuantity} {drugData?.form}
                    ,&nbsp;
                    {drugData?.dosage}
                  </span>
                </div>
                <DialogCloseButton
                  ref={closeButtonRef}
                  className="closeModal"
                  onClick={() => {
                    setIsModalOpen(false);
                    updateContactSent(false);
                  }}
                  img="x-close-icon.svg"
                  alt=""
                  height={24}
                  width={24}
                />
              </div>
              {contactSent ? (
                <div className="sendSuccessModal">
                  <h2>{`Sent! Check your ${
                    sendType === 'email' ? 'email' : 'messages'
                  } for your card.`}</h2>
                  <button
                    onClick={() => {
                      setIsModalOpen(false);
                      updateContactSent(false);
                    }}
                  >
                    Okay
                  </button>
                </div>
              ) : (
                <div
                  className={`actionModal ${
                    contactSent && 'purpleSuccessModal'
                  }`}
                  aria-modal={contactSent ? true : false}
                >
                  <SendContact
                    isEmail={sendType === 'email'}
                    drugData={drugData}
                    selectedPrice={cheapestPrice}
                    selectedPharmacyName={item?.Pharmacy?.Name}
                    buttonClicked={sendType === 'email'}
                    doNotMarket={item?.doNotMarket}
                    selectedDisplayQuantity={selectedDisplayQuantity}
                    setSignupModal={setShowSignupModal}
                    contactSent={contactSent}
                    updateContactSent={updateContactSent}
                    eventObj={sendCouponObj}
                    sendText="Send coupon"
                  />
                </div>
              )}
            </Dialog>
          </div>
        </div>
      )}
      <div className="CouponPageABMain">
        <Breadcrumb>
          <a href="/">{`Home`}</a>
          <span>
            <a
              href={`/prescription/${drugData?.seoName}`}
            >{`${drugName} Coupons & Prices`}</a>
          </span>
        </Breadcrumb>
        <div className="headingWrapper">
          <span>{`Your ${drugName} coupon`}</span>
          <div className="links">
            <p>Show this coupon to your pharmacist.</p>
            <a
              className="drugPageLink"
              href={`/prescription/${drugData?.seoName}`}
            >
              Return to all coupons
            </a>
          </div>
        </div>
        <div className="couponMainContainer">
          {isContactLoading ? (
            <div className="loaderContainer">
              <img
                src="/content/images/loader/loading.gif"
                alt={t('Coupon card loading')}
                className="couponLoader"
              />
            </div>
          ) : (
            <div className="couponContainer">
              <div className="drugDetailsWrapper">
                <div className="drugDetails">
                  <div className="drugNameWrapper">
                    <h2>{drugName}</h2>
                    <span>
                      {selectedDisplayQuantity} {drugData?.form},&nbsp;
                      {drugData?.dosage}
                    </span>
                  </div>
                  {item?.Pharmacy?.LogoUrl && (
                    <div className="logo">
                      <img
                        className="logo"
                        src={item.Pharmacy.LogoUrl}
                        alt={item?.Pharmacy?.Name}
                        width="172px"
                        height="48px"
                      />
                    </div>
                  )}
                  {!item?.Pharmacy?.LogoUrl && (
                    <div className="logo pharmacyTextLogo">
                      <p>{item?.Pharmacy?.Name}</p>
                    </div>
                  )}
                  {item?.Pharmacy?.onlinePharmacy && (
                    <div className="onlinePharmacy">Online only</div>
                  )}
                </div>
                <PriceInfoToolTip
                  isLoggedIn={isLoggedIn}
                  cheapestPrice={cheapestPrice}
                  handleLoyaltySignUpClick={handleLoyaltySignUpClick}
                  eventObj={eventObj}
                  couponShowHideInfoTooltipFunc={couponShowHideInfoTooltipFunc}
                  pharmacyName={item?.Pharmacy?.Name || ''}
                  isFromCouponPage={true}
                />
              </div>
              {!fetchContactError && (
                <div className="couponImageWrapper">
                  <div
                    className="couponCard"
                    data-bin={hiddenParams.bin}
                    data-pcn={hiddenParams.pcn}
                    data-groupnumber={hiddenParams.grpNumber}
                    data-authnumber={hiddenParams.authNumber}
                    data-pharmacyname={item?.Pharmacy?.Name}
                    data-logourl={item?.Pharmacy?.LogoUrl}
                  >
                    {pdfUrl && (
                      <Image
                        imageUrl={pdfUrl}
                        imageAlt={t('discount-card-param', {
                          pharmacy: _.getPharmacyALTName(
                            item?.Pharmacy?.Name || ''
                          )
                        })}
                        imageClass="contactImage"
                        containerClass="imageContainer"
                        loaderClass="loaderImage"
                        loaderalt={t('Coupon card loading')}
                        role="progressbar"
                      />
                    )}
                  </div>
                  {pdfUrl && <p>Show this coupon at the pharmacy counter.</p>}
                </div>
              )}
            </div>
          )}
          {!isContactLoading && (
            <div className="buttonsWrapper">
              <button
                className="dialogComponent themeFocus"
                id="text"
                onClick={e => handleTextEmailCoupon(e, 'text')}
              >
                <img
                  src="/content/images/icons/message.svg"
                  width="24px"
                  height="24px"
                />
                <span>Text</span>
              </button>
              <button
                className="dialogComponent themeFocus"
                id="email"
                onClick={e => handleTextEmailCoupon(e, 'email')}
              >
                <img
                  src="/content/images/icons/email.svg"
                  width="24px"
                  height="24px"
                />
                <span>Email</span>
              </button>
              {pdfLoading ? (
                <div className="pdfLoaderCointainer">
                  <img
                    src="/content/images/loader/loading.gif"
                    alt="loader"
                    className="pdfLoader"
                    width={48}
                    height={48}
                  />
                </div>
              ) : (
                <button
                  className="dialogComponent themeFocus"
                  onClick={handlePrintClick}
                >
                  <img
                    src="/content/images/icons/print.svg"
                    width="24px"
                    height="24px"
                  />
                  <span>{t('Print')}</span>
                </button>
              )}
            </div>
          )}
          {!isContactLoading &&
            item?.Prices[0]?.PBAClientName === WALMART_PBA_CLIENT_NAME &&
            !contactSent && (
              <p className="pricingMsg">
                {t('WALMART_PHARMACY_DESCRIPTION_2')}
              </p>
            )}
        </div>
        <SignupPromoBanner isFromCouponPage={true} />
        <div className="howToGetPrice">
          <span>How to get SingleCare’s low price</span>
          <ol>
            <li>Save this coupon; you can email, text, or print it.</li>
            <li>
              Optional: Create a free SingleCare account to unlock Member Bonus
              Savings. It's optional but recommended—you could miss out on extra
              discounts without it.
            </li>
            <li>
              Show your coupon to the pharmacy or call ahead and let them know
              you have SingleCare savings codes.
            </li>
          </ol>
        </div>
        <div className="instructionsWrapper">
          <div className="customerInstructions">
            <span>
              <img
                src="/content/images/icons/user.svg"
                width="24px"
                height="24px"
                alt=""
              />
              Customer Instructions
            </span>
            <p>
              To receive the SingleCare price, show your coupon at the pharmacy
              or call the pharmacy ahead of time and let them know you’d like to
              use Single Care’s savings codes when filling your prescription.
              <br />
              <br />
              Should you need assistance, please call us at:{' '}
              <a href="tel:844-234-3057">844-234-3057</a>
            </p>
          </div>
          <div className="pharmacistInstructions">
            <span>
              <img
                src="/content/images/icons/new-pill-bottle.svg"
                width="24px"
                height="24px"
                alt=""
              />
              Pharmacist Instructions
            </span>
            <p>
              Please use these BIN, GRP, and PCN codes in order to ensure this
              customer receives the correct discount. SingleCare is available at
              over 35,000 pharmacies nationwide.
              <br />
              <br />
              <br />
              For pharmacist support, please call us at:{' '}
              <a href="tel:800-960-6918">800-960-6918</a>
            </p>
          </div>
        </div>
        <div className="faqsContainer">
          <h2>Frequently asked questions</h2>
          {modifiedFaqs.map((item, id) => {
            return (
              <div id="faqsContainer" className="faqs" key={id}>
                <h3 className="faq--qus">{item.Question}</h3>
                <p
                  className="faq--a"
                  dangerouslySetInnerHTML={{
                    __html: item.Answer
                  }}
                ></p>
              </div>
            );
          })}
        </div>
        <AppPromoV1
          ctaLinks={DRUG_CLASS_CTA}
          classes="purpleBg"
          isFromCouponPage={true}
        />
        <div className="bottomBox">
          <p className="bottomPara">
            This coupon reflects pricing as of {_.getFormattedDate(Date())}
            &nbsp;for the selected pharmacy and does not include any sales taxes
            which vary by state. This coupon may work at other pharmacies but
            specific pricing may vary. For up-to-date pricing and coupons,
            please check our website or download our app.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CouponPageAB;
